import { Global, css } from '@emotion/react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GlobalStyle = (props: any) => (
  <Global
    {...props}
    styles={css`
      html,
      body,
      #root,
      #__next {
        height: 100%;
      }

      body {
        margin: 0;
      }

      .MuiCardHeader-action .MuiIconButton-root {
        padding: 4px;
        width: 28px;
        height: 28px;
      }

      body > iframe {
        pointer-events: none;
      }

      *:focus {
        outline: none;
      }
    `}
  />
)
